<template>
  <li
    class="todo"
    :class="{ completed: completed, editing: editing }"
  >
    <div class="view">
      <input
        v-model="completedState"
        class="toggle"
        type="checkbox"
      >
      <label @dblclick="editTodo()">
        {{ title }}
      </label>
      <button
        class="destroy"
        @click="removeTodo"
      />
    </div>
    <input
      v-model.trim="newTitle"
      v-todo-focus="editing"
      class="edit"
      type="text"
      @blur="doneEdit()"
      @keyup.enter="doneEdit()"
      @keyup.esc="cancelEdit()"
    >
  </li>
</template>

<script>
export default {
  directives: {
    "todo-focus": function(el, binding) {
      if (binding.value) {
        el.focus();
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    completed: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      newTitle: this.title,
      editing: false
    };
  },
  computed: {
    completedState: {
      get() {
        return this.completed;
      },
      set(completed) {
        if (completed) {
          this.$emit("complete");
        } else {
          this.$emit("reopen");
        }
      }
    }
  },
  methods: {
    editTodo() {
      this.editing = true;
    },
    doneEdit() {
      if (!this.editing) {
        return;
      }
      this.editing = false;
      if (!this.newTitle) {
        this.removeTodo();
      } else {
        this.$emit("update:title", this.newTitle);
      }
    },
    cancelEdit() {
      this.editing = false;
      this.newTitle = this.title;
    },
    removeTodo() {
      this.$emit("remove");
    }
  }
};
</script>

<style scoped>
.todo-list li label {
  white-space: normal;
}
</style>
